export enum SolarQuoteSteps {
  LEAD = 'LEAD',
  QUOTE = 'QUOTE',
}

export enum SolarQuoteAdjustmentType {
  Panel = 'Panel',
  TeslaPowerwall = 'Tesla Powerwall',
  ElectricBill = 'electric_bill',
}

export const SolarQuoteStepOrder = [
  SolarQuoteSteps.LEAD,
  SolarQuoteSteps.QUOTE,
];
